// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f3dfe58","239":"dae25263","455":"edec3784","488":"ebc8be06"}[chunkId] + ".chunk.js";
};